
import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const AboutCTA = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-kaija-light to-kaija-sage text-center">
      <div className="container-custom">
        <h2 className="text-2xl md:text-3xl font-medium mb-6">Alusta enda teekonda</h2>
        <p className="text-gray-700 mb-8 max-w-2xl mx-auto text-lg">
          Võta ühendust ja astu esimene samm oma isikliku arengu ja muutuste suunas.
        </p>
        <Button asChild className="bg-kaija-slate hover:bg-opacity-90 text-white px-8 py-6 text-lg group transition-all duration-300">
          <Link to="/contact" className="flex items-center">
            Võta ühendust <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
          </Link>
        </Button>
      </div>
    </section>
  );
};

export default AboutCTA;
